// src/api_scripts/getskillprofilesList.js
import { fetchAllPages } from "../paginationUtils";

const getskillprofilesList = async (skillprofilesListName, orgId, accessToken, setProgress) => {
  const relativeUri = `organization/${orgId}/v2/skill-profile`;

  try {
    const dataArray = await fetchAllPages(relativeUri, accessToken, setProgress, "Skill Profiles");
    console.log("Get Skill Profiles API Response Data (all pages):", dataArray.length, "items");
    return dataArray;

  } catch (error) {
    console.error(`Error fetching Skill Profiles:`, error);
    throw error;
  }
};

export default getskillprofilesList;